import React, {
  Component,
  useContext,
  useRef,
  useState,
  useEffect,
} from "react";
import styled, { css, ThemeProvider } from "styled-components";
import Colorer from "color";
import Bg from "../Bg";
import { ProductContext } from "../../context";
import { Link } from "react-router-dom";

export const T = styled.div`

  line-height: 1.4em;

  font-size: 1em;
      ${({ size }) =>
        size &&
        css`
          font-size: ${size};
        `};
    ${({ lg }) =>
      Boolean(lg) &&
      css`
        font-size: 1.2em;
      `};
    ${({ md }) =>
    Boolean(md) &&
    css`
      font-size: 1em;
    `};
  ${({ sm }) =>
    Boolean(sm) &&
    css`
      font-size: 0.9em;
    `};
  ${({ xs }) =>
    Boolean(xs) &&
    css`
      font-size: 0.85em;
    `};
  ${({ opacity }) =>
    opacity &&
    css`
      opacity: ${opacity};
    `};
  ${({style}) => style && css`
    ...style
  `}


`;

export const CssImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: transparent;
  border-radius: 6px;
  /* margin-right: 16px; */
  background-size: 90%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  width: 100%;
`;

export const CssPrice = styled.div`
  display: inline-flex;
  justify-content: flex-end;
  /* font-weight: 500; */
  ${({ size }) =>
    size === "lg" &&
    css`
      font-size: 1.2em;
    `};
  ${({ size }) =>
    size === "sm" &&
    css`
      font-size: 0.9em;
    `};
    color: ${({ theme }) =>
      Colorer(theme["colorAccent"])
        .alpha(0.8)
        .string()};
`;

export const CSSproductDesc = styled.div`
  font-weight: 400;
  font-size: 1.2em;
  opacity: 0.8;
`;

export const CSSuikit0 = styled.div`
  padding: 80px;
  width: 100%;
`;

export const UikitSection = ({ children, label }) => {
  return (
    <CSSuikitSection>
      <CSSuikitH>{label}</CSSuikitH>
      <div>{children}</div>
    </CSSuikitSection>
  );
};

export const CSSuikitH = styled.div`
  font-size: 24px;
  color: ${({ theme }) => theme["colorText"]};
`;


export const HH = ({ tag = "h1", paddings = true, style, normal, children }) => {
  let sizes = {
    h1: {
      padding: "0 0 16px 0",
      fontSize: "24px",
    },
    h2: {
      padding: "0 0 16px 0",
      fontSize: "20px",
    },
    h3: {
      padding: "0 0 16px 0",
      fontSize: "18px",
    },
    h4: {
      padding: "0 0 16px 0",
      fontSize: "16px",
    },
    h5: {
      padding: "0 0 8px 0",
      fontSize: "1em",
    },
  };

  return (
    <div
      style={{
        fontWeight: normal ? '400' : 'bolder',
        fontSize: sizes[tag]["fontSize"],
        padding: paddings ? sizes[tag]["padding"] : 0,
        ...style,
      }}
    >
      {children}
    </div>
  );
  /* if (tag === 'h1') return <div style={{fontSize: 24}}>{children}</div>;
  if (tag === 'h2') return <div style={{fontSize: 20}}>{children}</div>;
  if (tag === 'h3') return <div style={{fontSize: 18}}>{children}</div>;
  if (tag === 'h4') return <div style={{fontSize: 16}}>{children}</div>; */
};

export const CSSuikitSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-column-gap: 44px;
  border-bottom: 1px solid ${({ theme }) => theme["colorText"]};
  padding: 80px 0;
  margin-bottom: 40px;
`;

export const CSSuikitElement = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  grid-column-gap: 44px;
  padding: 0 0 44px 0;
`;

export const CSSuikitInfo = styled.div`
  color: ${({ theme }) =>
    Colorer(theme["colorAccent"])
      .alpha(0.8)
      .string()};
  /* font-size: 14px; */
  line-height: 120%;
`;

export const CSSpsFormGroup = styled.div`
  padding: 0 0 ${({ theme }) => `${getReasonablePaddings(theme["paddings"])}px`}
    0;
`;




export const Paper = (props)=> {
  const {children, style, indentation = 'md'} = {...props};

  const valueFromContext = useContext(ProductContext);

  let theme=valueFromContext['theme']

  return <ThemeProvider theme={theme}>
  <CssPaper {...props}>{children}</CssPaper>
</ThemeProvider>
}




export const CssPaper = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colorText};
  /* border-bottom: 1px solid ${({ theme }) =>
    Colorer(theme.colorText)
      .alpha(0.3)
      .string()}; */
  border-radius: ${({ theme }) => `${theme["borderRadius"]}px`};
  background:  ${({ theme }) =>
    Colorer(theme.colorBg)
      .alpha(0.4)
      .string()};
  /* border: 1px solid ${({ theme }) =>
    Colorer(theme.colorBg)
      .alpha(0.4)
      .string()}; */

      ${({indentation}) => indentation === 'md' || !indentation && css`padding: 16px 16px 16px 16px;`}
      ${({indentation}) => indentation === 'lg' && css`padding: 24px 24px 24px 24px;`}
      ${({indentation}) => indentation === 'sm' && css`padding: 8px 8px 8px 8px;`}


`;


export const Button = (props)=> {
  const {children} = {...props};

  const valueFromContext = useContext(ProductContext);

  let theme=valueFromContext['theme']

  return <ThemeProvider theme={theme}>
  <CssButton {...props}>{children}</CssButton>
  </ThemeProvider>
}



export const CssButton = styled.div`

  & div {
    text-decoration: none;
  }
  & a {
    text-decoration: none;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
  }

  transition: all 150ms ease-in-out;
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  flex-direction:row;
  line-height:1em;
  flex-direction:column;
  align-items: center;
  justify-content:center;
  font-weight: 500;
  text-transform: uppercase;
  color: ${({ theme, color }) =>
    color === "colorText" ? theme["colorText"] : theme["colorAccentText"]};

  border-radius: ${({ theme }) => theme.borderRadius / 2}px;

  background: ${({ theme }) => theme.colorAccent};
  padding: 0.6em 1em 0.5em 1em;

  /* border: 1px solid ${({ theme }) => theme.colorAccent}; */

  cursor: pointer;
  ${({ appearance }) =>
    appearance === "ghost" &&
    css`
      box-shadow: inset 0 0 0 1px
        ${({ theme }) =>
          Colorer(theme.colorAccent)
            // .darken(10)
            .alpha(0.3)
            .string()};
      color: ${({ theme }) => theme.colorAccent};
      background: transparent;
    `}

  ${({ appearance }) =>
    appearance === "secondary" &&
    css`
      color: ${({ theme }) => theme.colorAccent};
      border: 1px solid transparent;
      background: ${({ theme }) =>
        Colorer(theme.colorAccent)
          .alpha(0.1)
          .string()};
      opacity: 1;
    `}

  ${({ appearance }) =>
    appearance === "flatten" &&
    css`
      color: ${({ theme }) => theme.colorAccent};
      border: 1px solid transparent;
      background: transparent;
      opacity: 1;
      padding: 0 0;
      margin: 0 0.2em 0;
      line-height: 1.4em;
      font-size: 1.1em;
    `}

  ${({ icon }) =>
    icon &&
    css`
      &::before {
        content: ${({ icon }) => icon};
      }
    `}

  &:hover {
    text-decoration: none !important;
    /* background-color: ${({ theme, appearance }) =>
      appearance !== "flatten" && Colorer(theme.colorAccent)}; */
    background-color: ${({ theme, appearance }) =>
      appearance !== "flatten" &&
      Colorer(theme.colorAccent)
        .lighten(0.4)
        .saturate(2)
        // .alpha(0.8)
        .string()};
    opacity: ${({ appearance }) => (appearance === "flatten" ? 0.6 : 1)};
  };

  ${({ size }) =>
    typeof size === "undefined" ||
    (size === "md" &&
      css`
        font-size: 0.9em;
      `)}

  ${({ size }) =>
    size === "lg" &&
    css`
      font-size: 1.1em;
    `}

  ${({ size }) =>
    size === "sm" &&
    css`
      font-size: 0.8em;
    `}

  ${({ size }) =>
    size === "xs" &&
    css`
      font-size: 0.6em;
    `}

  ${({ blocked }) =>
    blocked &&
    css`
      color: ${({ theme }) => theme.colorAccentText};
      border: 1px solid transparent;
      background: #ccc;
      opacity: 0.7;
      cursor: not-allowed;
      &:hover {
        background: #ccc;
      }
    `}


`;

export const CssH1 = styled.div`
  color: currentColor;
  font-size: 22px;
  line-height: 32px;
  letter-spacing: -0.01em;
  font-weight: 700;
  flex-shrink: 0;
  /* padding-bottom: 16px; */
  /* margin-bottom: 29px; */
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.16); */
  align-items: initial;
`;

export const CssFormGroup = styled.div`
  padding-bottom: 12px;
  display: flex;
  width: 100%;
  /* max-width: 640px; */
  flex-direction: column;
  align-items: ${({ alignment }) => (alignment ? alignment : "flex-start")};
  ${({ indentation }) =>
    indentation &&
    css`
      padding-bottom: ${({ indentation }) => {
        if (!indentation) {
          return "16px";
        }
        if (indentation === "sm") {
          return "8px";
        }
        if (indentation === "lg") {
          return "24px";
        }
        if (indentation === "xs") {
          return "0px";
        }
      }};
    `}
`;

export const CssPopSection = styled.div`
  /* display: flex; */
  width: 100%;
  max-width: 640px;
  color: ${({ theme }) =>
    Colorer(theme.colorText)
      .alpha(0.6)
      .string()};
  /* border-top: 1px solid ${({ theme }) =>
    Colorer(theme.colorText)
      .alpha(0.2)
      .string()}; */
  /* padding-top: 16px; */
  /* padding-bottom: 16px; */
  /* & input {
    background:  ${({ theme }) =>
      Colorer(theme.colorBg)
        .alpha(0.7)
        .string()};
    border: 1px solid ${({ theme }) =>
      Colorer(theme.colorBg)
        .alpha(0.8)
        .string()};
    border: 1px solid transparent;
    box-shadow: inset 0px 0px 0px 0px ${({ theme }) =>
      Colorer(theme.colorBg)
        .alpha(0.1)
        .string()};
    box-shadow: inset 0px 0px 0px 0px transparent;
    color: ${({ theme }) => theme.colorText};
  }; */
  /* & input:hover {
    border: 1px solid ${({ theme }) =>
      Colorer(theme.colorText)
        .alpha(0.6)
        .string()};
    box-shadow: inset 0px 0px 0px 1px ${({ theme }) =>
      Colorer(theme.colorText)
        .alpha(0.2)
        .string()};
  };
  & input:focus {
    background:  ${({ theme }) =>
      Colorer(theme.colorBg)
        // .alpha(0.4)
        .string()};
    color: ${({ theme }) => theme.colorAccent};
    border: 1px solid ${({ theme }) => theme.colorAccent};
    box-shadow: inset 0px 0px 1px 2px ${({ theme }) => theme.colorAccent};
  }; */
  & svg {
    color: ${({ theme }) => theme.colorAccent} !important;
  };
  /* ${CssPopSection}:nth-child(1) ${CssPopSection} {
    border-top: none;
    padding-top: 0;
  } */
`;

export const getReasonableBorderRadius = (borderRadius, multiplier) => {
  borderRadius = typeof multiplier !== "undefined" ? borderRadius * multiplier : borderRadius;
  return borderRadius > (8 * multiplier) ? "12px" : `${borderRadius}px`;
};

export const getReasonablePaddings = (padding, multiplier = 1, origin = 'md') => {
  padding = typeof multiplier !== "undefined" ? padding * multiplier : padding;
  let max = 44;
  max = origin === "xlg" ? 44 : max;
  max = origin === "lg" ? 36 : max;
  max = origin === "md" ? 24 : max;
  max = origin === "sm" ? 8 : max;
  max = origin === "xs" ? 0 : max;
  // console.log('max = ', max);

  return padding > max ? max : padding;
};

export const CssPopBodyBorder = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: ${({ fullscreen, theme }) =>
    !fullscreen ? getReasonableBorderRadius(theme["borderRadius"]) : "0px"};
  box-shadow: inset 0px 0px 1px 1px
    ${({ theme }) =>
      Colorer(theme.colorText)
        .alpha(0.1)
        .string()};
  z-index: 1;
  user-select: none;
  pointer-events: none !important;
`;



export const HR = ({ indentation = 'lg', color='colorText', style, opacity=0.4, ui }) => {
  const valueFromContext = useContext(ProductContext);
  let theme=valueFromContext['theme']
  return (<ContentBlock indentation={indentation}>
    <hr style={{backgroundColor: ui ? 'black' : theme[color], opacity: opacity, ...style }}/>
  </ContentBlock>)
}


export const ContentBlock = ({
  children,
  border = true,
  appearance = "flatten",
  paddings,
  indentation = "md",
  theme,
  label,
  section,
  handle,
  active = typeof active !== "undefined" ? active : true,
  style,
}) => {
  const valueFromContext = React.useContext(ProductContext);
  // console.log('valueFromContext = ', valueFromContext);

  let margin = 0;
  if (indentation === "sm")
    margin = getReasonablePaddings(
      valueFromContext.getTheme()["paddings"],
      0.5,
      "sm"
    );
  if (indentation === "xs")
    margin = 0;
  if (indentation === "md")
    margin = getReasonablePaddings(
      valueFromContext.getTheme()["paddings"],
      1,
      "md"
    );
  if (indentation === "lg")
    margin = getReasonablePaddings(
      valueFromContext.getTheme()["paddings"],
      2,
      "lg"
    );
  if (indentation === "xlg")
    margin = getReasonablePaddings(
      valueFromContext.getTheme()["paddings"],
      6,
      "xlg"
    );
  if (typeof indentation === "number")
    margin = getReasonablePaddings(
      valueFromContext.getTheme()["paddings"],
      indentation,
      "md"
    );

  if (typeof paddings !== "undefined") {
    if (paddings === "sm")
      paddings = getReasonablePaddings(
        valueFromContext.getTheme()["paddings"],
        0.5,
        "sm"
      );
    if (paddings === "md")
      paddings = getReasonablePaddings(
        valueFromContext.getTheme()["paddings"],
        1,
        "md"
      );
    if (paddings === "lg")
      paddings = getReasonablePaddings(
        valueFromContext.getTheme()["paddings"],
        2,
        "lg"
      );
    if (paddings === "xlg")
      paddings = getReasonablePaddings(
        valueFromContext.getTheme()["paddings"],
        6,
        "xlg"
      );
    if (typeof paddings === "number")
      paddings = getReasonablePaddings(
        valueFromContext.getTheme()["paddings"],
        paddings,
        "md"
      );
  }
  paddings = appearance === "bg" ? "md" : paddings;
  paddings = appearance === "bg-blurred" ? "md" : paddings;

  return (
    <CssContentBlock
      border={border}
      paddings={paddings}
      label={label}
      indentation={indentation}
      appearance={appearance}
      theme={theme}
      style={{
        zIndex: active ? 1 : 0,
        margin: `0 0 ${margin}px 0`,
        // padding: `${paddings}px`,
        ...style,
      }}
    >
      {/* {border
    && appearance !== 'flatten'
    && appearance !== 'transparent'
    && <CssPopBodyBorder theme={theme}/>} */}

      {handle && <CSSsection active={active} onClick={() => handle(section)} />}

      {!!label && (
        <HH paddings={true} tag={"h2"}>
          {label}
        </HH>
      )}

      <div className="__uikitb2c_contentblock_inner">{children}</div>

      {appearance === "bg" && (
        <SectionBack active={false}>
          <Bg
            absolute={true}
            effect={appearance === "bg" ? true : false}
            style={{
              borderRadius: theme
                ? `${getReasonableBorderRadius(theme["borderRadius"], 0.5)}`
                : 0,
              // borderRadius: 20,
              overflow: "hidden",
            }}
          />
        </SectionBack>
      )}

      {appearance === "bg-blurred" && (
        <SectionBack active={false}>
          <Bg
            absolute={true}
            effect={appearance === "bg-blurred" ? true : false}
            style={{
              borderRadius: theme
                ? `${getReasonableBorderRadius(theme["borderRadius"], 0.5)}`
                : 0,
              // borderRadius: 20,
              overflow: "hidden",
            }}
          />
        </SectionBack>
      )}

      {/* {appearance === 'bg' && <Bg absolute={true}/>} */}
      {/* {appearance === 'bg-blurred' && <Bg absolute={true} effect={true}/>} */}
    </CssContentBlock>
  );
};

export const CssContentBlock = styled.div`
  position: relative;
  z-index: 1;
  color: ${(props) => props.theme["colorText"]};

  & .__uikitb2c_contentblock_inner {
    position: relative;
    z-index: 2;
  }


  ${({ appearance }) =>
    (appearance === "primary" || appearance === "secondary") &&
    css`
    /* padding: ${(props) =>
      `${getReasonablePaddings(props.theme["paddings"]) * 3}px`}; */
    &::after {
      content: '';
      position: absolute;
      left: 0px;
      right: 0px;
      top: 0px;
      bottom: 0px;
      z-index: 0;
      background: ${({ theme }) => theme["colorText"]};
      border-radius: ${({ theme }) =>
        `${getReasonableBorderRadius(theme["borderRadius"], 0.5)}`};
      box-shadow: ${({ theme, border }) =>
        border
          ? `inset 0px 0px 0px 1px ${Colorer(theme["colorText"])
              .alpha(0.2)
              .string()}`
          : "none"};
    }
  `}
  ${({ appearance }) =>
    appearance === "secondary" &&
    appearance !== "flatten" &&
    css`
    /* padding: ${(props) =>
      `${getReasonablePaddings(props.theme["paddings"]) * 3}px`}; */
    &::after {
      content: '';
      opacity: 0.4;
      background: ${({ theme }) =>
        Colorer(theme["colorBg"])
          .darken(0.4)
          .string()};
    }
  `}


  ${({ appearance }) =>
    appearance === "transparent" &&
    css`
      &::after {
        background: transparent;
      }
    `}

  ${({ appearance }) =>
    appearance !== "flatten" &&
    css`
      z-index: 1;
      padding: ${({ theme, paddings = 1 }) =>
        `${(getReasonablePaddings(theme["paddings"]), paddings)}px`};
      border-radius: ${({ theme }) =>
        `${getReasonableBorderRadius(theme["borderRadius"], 0.5)}`};
    `}




`;

export const CSSlink = styled(Link)`
  color: ${({ theme }) => theme["colorAccent"]};
  &:hover {
    text-decoration: none;
  }
`;

export const CSSsection = styled.div`
  position: absolute;
  top: ${(props) => `-${props.theme["paddings"] + 16}px`};
  bottom: ${(props) => `-${props.theme["paddings"]}px`};
  right: ${(props) => `-${props.theme["paddings"] + 16}px`};
  left: ${(props) => `-${props.theme["paddings"] + 16}px`};
  border-radius: ${(props) =>
    getReasonableBorderRadius(props.theme["borderRadius"])};
  cursor: pointer;
  z-index: 1;

  ${({ active }) =>
    active &&
    css`
      /* pointer-events: none; */
      /* z-index: 10; */
    `}

  ${({ active }) =>
    !active &&
    css`
      z-index: 10;
    `}
`;

const SectionBack = styled.div`
  overflow: hidden;
  position: absolute;
  /* top: -24px;
  right: -24px;
  bottom: -24px;
  left: -24px; */


  /* top: ${(props) => `-${props.theme["paddings"] * 2}px`};
  bottom:  ${(props) => `-${props.theme["paddings"] * 2}px`}; */
  top: 0px;
  bottom:  0px;
  right: 0px;
  left: 0px;
  transition: all 150ms ease-in-out;
  /* opacity: 0; */
  background: ${(props) => props.theme["colorBg"]};
  z-index: 0;

    border-radius: ${({ theme }) =>
      getReasonableBorderRadius(theme["borderRadius"])};

    overflow: hidden;



    z-index: -1;
    /* opacity: 0.1; */
    /* right:  ${(props) => `-${props.theme["paddings"] * 4}px`}; */
    /* left:  ${(props) => `-${props.theme["paddings"] * 4}px`}; */
    background: ${({ active, theme }) =>
      active
        ? Colorer(theme.colorBg)
            .darken(0)
            .string()
        : Colorer(theme.colorBg)
            .darken(0.2)
            .string()};


  box-shadow: 0px 8px 20px -16px rgba(0,0,0,0.8);

`;
